import { createSelector } from 'reselect';
import { MODULE_NAME } from './constants';

export const moduleState = (state: { [key: string]: string }) => state[MODULE_NAME];

export const error = createSelector(moduleState, (state) => state || undefined);

export const errorMessage = (state: { [key: string]: string }) => error(state);
